// #1707 (tracker #1677) moved this hook into app-base's generic
// `data/use-query-ready` (parameterized by a `DataSchema`); this wrapper is a
// one-line instantiation at `LogbookSchema` with no behavior of its own.
import { useQueryReady as genericUseQueryReady } from "app-base/data/use-query-ready"
import type { FetchIds } from "./Connections"
import type { DataStore } from "./Store"
import type { SchemaEntity } from "../Types/Generated/LogbookModel/Schema"

export function useQueryReady<K extends SchemaEntity>(
  store: DataStore,
  type: K,
  ids: FetchIds<K>,
  shouldFetch: boolean,
  readyWhenSkipped: boolean,
): boolean {
  const fetched = shouldFetch && store.isQueryFetched(type, ids);
  return genericUseQueryReady(
    store,
    type,
    ids,
    shouldFetch && !fetched,
    readyWhenSkipped || fetched,
  );
}
